import Radium from 'radium'

export const fadeInOnHover = () => ({
  opacity: 0,
  ':hover': {
    opacity: 1,
    transitionDuration: '100ms',
    transitionTimingFunction: 'ease-in',
    transitionProperty: 'opacity',
  },
})

export const slideInRightOnHover = (size) => ({
  right: size,
  ':hover': {
    right: 0,
    transitionDuration: '200ms',
    transitionTimingFunction: 'ease-in',
    transitionProperty: 'right',
  },
})

export const backgroundColorOnHover = (color) => ({
  transitionDuration: '75ms',
  transitionTimingFunction: 'ease-in',
  transitionProperty: 'background-color',
  ':hover': {
    backgroundColor: color,
  },
})

const zoomInFrames = Radium.keyframes({
  '0%': {
    opacity: 0,
    transform: 'scale3d(.3,.3,.3)',
  },
  '50%': { opacity: 1 },
}, 'zoomInFrames')

const zoomIn = (duration) => ({
  animationName: zoomInFrames,
  animationDuration: duration || '250ms',
})

const shakeFrames = Radium.keyframes({
  'from, to': {
    transform: 'translate3d(0, 0, 0)',
  },
  '10%, 30%, 50%, 70%, 90%': {
    transform: 'translate3d(-10px, 0, 0)',
  },
  '20%, 40%, 60%, 80%': {
    transform: 'translate3d(10px, 0, 0)',
  },
})

const shake = (duration) => ({
  animationName: shakeFrames,
  animationDuration: duration || '500ms',
})

export default {
  fadeInOnHover,
  slideInRightOnHover,
  backgroundColorOnHover,
  zoomInFrames,
  zoomIn,
  shakeFrames,
  shake,
}
